// apps/web/src/lib/kanban/erros.ts — Fase 11 (WR-WEB-13).
// Mensagens amigáveis para falhas de carga do quadro. `apiFetch` lança o corpo cru da resposta
// (ex.: {"statusCode":401,...}) ou "Erro <status> ao consultar ...": nada disso vai para a tela.

export const MENSAGEM_SESSAO_EXPIRADA = 'Sua sessão expirou. Entre novamente para ver o quadro.';
export const MENSAGEM_SEM_PERMISSAO = 'Você não tem permissão para ver este quadro.';
export const MENSAGEM_FALHA_CARGA = 'Não foi possível carregar o quadro. Tente novamente.';

function statusDoErro(erro: unknown): number | null {
  if (!(erro instanceof Error)) return null;
  const texto = erro.message.trim();
  try {
    const corpo = JSON.parse(texto) as { statusCode?: unknown };
    if (corpo && typeof corpo === 'object' && typeof corpo.statusCode === 'number') return corpo.statusCode;
  } catch {
    // Não é JSON: tenta o formato "Erro 401 ao consultar ...".
  }
  const achado = /^Erro (\d{3})\b/.exec(texto);
  return achado ? Number(achado[1]) : null;
}

export function mensagemErroCarga(erro: unknown): string {
  const status = statusDoErro(erro);
  if (status === 401) return MENSAGEM_SESSAO_EXPIRADA;
  if (status === 403) return MENSAGEM_SEM_PERMISSAO;
  return MENSAGEM_FALHA_CARGA;
}
